export enum FelloAddressStatus {
  VALIDATION_PENDING = "V_PENDING",
  VALIDATION_FAILED = "V_FAILED",
  VALIDATION_SUCCESS = "V_SUCCESS",
  CUSTOM_VSUCCESS = "C_SUCCESS",
  CUSTOM_VFAILED = "C_FAILED"
}
